import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeliveryAsset } from '../../models/delivery-asset.model';
import * as fromDeliveryAssetReducer from '../reducers/delivery-assets.reducer';

// eslint-disable-next-line max-len
export const getDeliveryAssetState = createFeatureSelector<fromDeliveryAssetReducer.DeliveryAssetState>(
  'deliveryAssets',
);

export const getDeliveryAssets = createSelector(
  getDeliveryAssetState,
  (resp: fromDeliveryAssetReducer.DeliveryAssetState) => resp.assets,
);

export const getSelectedAsset = createSelector(getDeliveryAssets, (assets: DeliveryAsset[]) => {
  const selected = assets.find((asset: DeliveryAsset) => asset.isSelected);

  return selected || <DeliveryAsset>{};
});

export const getImageAssets = createSelector(getDeliveryAssets, (assets: DeliveryAsset[]) => {
  const imageAssets = assets.filter((asset: DeliveryAsset) => asset.mediaType === 'IMG');

  return imageAssets || [];
});

export const getMediaAssets = createSelector(getDeliveryAssets, (assets: DeliveryAsset[]) => {
  const mediaAssets = assets.filter(
    (asset: DeliveryAsset) => asset.mediaType === 'AUDIO' || asset.mediaType === 'VIDEO',
  );

  return mediaAssets || [];
});

export const getVideoTypes = createSelector(getSelectedAsset, (asset: DeliveryAsset) => {
  const videoTypes = asset && asset.types;

  return videoTypes;
});

export const getIsPlayingAllAssets = createSelector(
  getDeliveryAssetState,
  fromDeliveryAssetReducer.selectPlayingAll,
);

export const getAssetLoading = createSelector(
  getDeliveryAssetState,
  fromDeliveryAssetReducer.selectLoading,
);

export const getIsAssetDefaultView = createSelector(
  getDeliveryAssetState,
  fromDeliveryAssetReducer.selectDefaultView,
);

export const isDownloadingAll = createSelector(
  getDeliveryAssetState,
  (resp: fromDeliveryAssetReducer.DeliveryAssetState) => resp.isDownloadingAll,
);

export const isDownloadAllAvailable = createSelector(
  getDeliveryAssets,
  (assets: DeliveryAsset[]) => {
    let available = false;

    assets.forEach((asset: DeliveryAsset) => {
      if (asset.isAllowedToDownload) {
        available = true;
      }
    });

    return available;
  },
);

export const isAllDownloaded = createSelector(getDeliveryAssets, (assets: DeliveryAsset[]) => {
  let downloaded = true;

  if (assets) {
    assets.forEach((asset: DeliveryAsset) => {
      if (asset.isAllowedToDownload && !asset.isDownloaded) {
        downloaded = false;
      }
    });
  }

  return downloaded;
});

export const isInfoView = createSelector(
  getDeliveryAssetState,
  fromDeliveryAssetReducer.selectInfoView,
);

export const selectAssetMeiaType = createSelector(
  getSelectedAsset, (resp: DeliveryAsset) => resp?.mediaType,
);
